$(function () {
    $('.indicator').first().addClass('active');
    $('.carousel-item').first().addClass('active');

    // 在庫数
    let valid_stock_num = $('.stock-num').data('stock-num');

    // ロード時
    $(document).ready(function () {
        let tooltip = $('.count-up-btn-tooltip');
        let quantity = $('.product-quantity').text();
        let max = $('.max-value').text();
        if(valid_stock_num > max) {
            if (quantity == max) {
                $('.count-up-btn').addClass('over-quantity');
                tooltip.removeClass('no-display');
                tooltip.text("購入可能数の上限に達しています。");
            }
        }else {
            if (quantity == valid_stock_num) {
                $('.count-up-btn').addClass('over-quantity');
                tooltip.removeClass('no-display');
                tooltip.text("在庫数の上限に達しています。");
            }
        }

        // 医療従事者向けポップアップ
        let medical_personnel_dialog = $('.medical-personnel-dialog');
        let medical_session = sessionStorage.getItem("medical_personnel");
        let medical_flg = medical_personnel_dialog.data('medical-flg');
        if (medical_session) {
            $('body').css('display', 'flex');
        } else {
            if (medical_flg == 0) {
                $('body').css('display', 'flex');
            } else {
                // ダイアログを表示
                $('.dialog-bg').css('background', '#fff');
                $(medical_personnel_dialog).show();
                $('body').css('display', 'flex');
            }
        }
    });

    // 選択した画像をメインに表示
    $('.sub-img').click(function () {
        var src = $(this).attr('src');
        $(".main-img").attr("src", src);
    });

    // 数量カウントアップ
    $('.count-up-btn').click(function () {
        let quantity = $('.product-quantity');
        let cnt = quantity.text();
        cnt++;

        let max = $('.max-value').text();

        if(valid_stock_num > max) {
            if (cnt <= max) {
                let tooltip = $('.count-up-btn-tooltip');
                quantity.text(cnt);
                $('.item-quantity').val(cnt);
                $(this).removeClass('over-quantity');
                tooltip.addClass('no-display');
                $('.count-down-btn').removeClass('over-quantity');
                if (cnt == max) {
                    $(this).addClass('over-quantity');
                    tooltip.removeClass('no-display');
                    tooltip.text("購入可能数の上限に達しています。");
                }
            }
        } else {
            if(cnt <= valid_stock_num) {
                let tooltip = $('.count-up-btn-tooltip');
                quantity.text(cnt);
                $('.item-quantity').val(cnt);
                $(this).removeClass('over-quantity');
                tooltip.addClass('no-display');
                $('.count-down-btn').removeClass('over-quantity');
                if (cnt == valid_stock_num) {
                    $(this).addClass('over-quantity');
                    tooltip.removeClass('no-display');
                    tooltip.text("在庫数の上限に達しています。");
                }
            }
        }
    });

    // 数量カウントダウン
    $('.count-down-btn').click(function () {
        let quantity = $('.product-quantity');
        let cnt = quantity.text();
        let max = $('.max-value').text();

        if (1 < cnt) {
            cnt--;
            quantity.text(cnt);
            $('.item-quantity').val(cnt);
            if (cnt == 1) {
                $(this).addClass('over-quantity');
            }
        }
        if(valid_stock_num > max) {
            if (cnt < max) {
                $('.count-up-btn').removeClass('over-quantity');
                $('.count-up-btn-tooltip').addClass('no-display');
            }
        } else {
            if (cnt < valid_stock_num) {
                $('.count-up-btn').removeClass('over-quantity');
                $('.count-up-btn-tooltip').addClass('no-display');
            }
        }
    });

    // お気に入りボタンクリック時
    $('.favorite-btn').click(function () {
        np_jp.lock();
        let _self = $(this);

        let $form = $('#form_favorite');
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            dataType: 'json',
        }).done(function (data) {
            $("[name=fav_flg]").val(data['favorite_flg']);
            if (data['favorite_flg'] === 1) {
                $('.favorite-added').removeClass('no-display')
                $('.favorite-no-added').addClass('no-display')
            } else {
                $('.favorite-added').addClass('no-display')
                $('.favorite-no-added').removeClass('no-display')
            }
            np_jp.unlock();
        })
    });


    // ゲストかつ、成分量がデータで存在する場合はログインダイアログを表示
    $(".not-login-cart").click(function () {
        let $isScrolling = 0;
        let item_prefix = $(this).data('item-prefix');
        let item_code = $(this).data('item-code');
        let item_branch = $(this).data('item-branch');
        let url = location.origin
                + '/item/detail?item_prefix=' + item_prefix
                + '&item_code=' + item_code
                + '&item_branch=' + item_branch;

        // ローカルストレージに遷移用のURLを保存
        localStorage.setItem('return_url', url);

        if ($isScrolling === 0) {
            let dialog_target = $(this).data('dialog-target');
            common.openDialog(dialog_target)
        }
    });
});
